import React, { useState, useEffect } from "react";
import { firestore } from "../../firebase-config";
import { collection, getDocs } from "firebase/firestore";
import "../../styles/administrationview.css";

const AdministrationDisplay = () => {
  const [members, setMembers] = useState([]);
  const [selectedMember, setSelectedMember] = useState(null);

  useEffect(() => {
    fetchMembers();
  }, []);

  const fetchMembers = async () => {
    try {
      const querySnapshot = await getDocs(collection(firestore, "administration"));
      let fetchedMembers = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Sort by createdAt timestamp in ASCENDING order (oldest first)
      fetchedMembers.sort((a, b) => {
        const timeA = a.createdAt || 0;
        const timeB = b.createdAt || 0;
        return timeA - timeB; // Changed from timeB - timeA
      });

      setMembers(fetchedMembers);
    } catch (error) {
      console.error("Error fetching members:", error);
    }
  };

  // Close modal if click outside or on close button
  const closeModal = () => setSelectedMember(null);

  return (
    <div className="admin-container">
      <h1 className="admin-heading">ADMINISTRATION</h1>
      <div className="yellow-line12"></div>
     
      <div className="admin-grid">
        {members.map((member) => (
          <div key={member.id} className="admin-card">
            <div className="admin-image-container">
              <img src={member.imageUrl} alt={member.name} className="admin-photo" />
            </div>
            <h3 className="admin-name">{member.name}</h3>
            <p className="admin-role">{member.role}</p>
            {member.qualification && (
              <p className="admin-qualification">{member.qualification}</p>
            )}
            <button
              onClick={() => setSelectedMember(member)}
              className="read-more-button"
            >
              Read More
            </button>
          </div>
        ))}
      </div>

      {selectedMember && (
        <div className="modal-overlay" onClick={closeModal}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()} // prevent closing modal when clicking inside
          >
            <button className="modal-close-btn" onClick={closeModal}>
              &times;
            </button>
            <div className="modal-body">
              <div className="modal-left">
                <img
                  src={selectedMember.imageUrl}
                  alt={selectedMember.name}
                  className="modal-photo"
                />
              </div>
              <div className="modal-header">
                <h2 className="modal-name">{selectedMember.name}</h2>
                <p className="modal-designation">Designation : {selectedMember.role}</p>
              </div>
              {selectedMember.qualification && (
                <div className="modal-qualification">
                  <p>Qualification : {selectedMember.qualification}</p>
                </div>
              )}
              {selectedMember.about && (
                <div className="modal-about">
                  <p>{selectedMember.about}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdministrationDisplay;